export default __webpack_public_path__ + "static/media/downloadBgMb.e8f24e08.png";